import { Link } from 'react-router-dom'
import type { ContentItem } from '../data/types'
import { DEITIES } from '../data/deities'
import { contentHref, youtubeWatchUrl } from '../data/content'

const TYPE_LABEL: Record<ContentItem['type'], string> = {
  'original-song': 'அசல் பாடல்',
  'traditional-stuti': 'ஸ்துதி',
  mantra: 'மந்திரம்',
  potri: 'பொற்றி',
  'spiritual-story': 'கதை',
  article: 'கட்டுரை',
}

export function ContentCard({ item }: { item: ContentItem }) {
  const deity = DEITIES.find((d) => d.id === item.deity)
  const watchUrl = youtubeWatchUrl(item.youtubeVideoId)

  return (
    <article className="content-card content-card--interactive">
      <Link className="content-card__main" to={contentHref(item)}>
        <span className="content-card__meta">
          {TYPE_LABEL[item.type]} · {deity?.nameTa}
        </span>
        <h3>{item.titleTa}</h3>
        <span className="content-card__en">{item.titleEn}</span>
        <p>{item.shortIntroTa}</p>
      </Link>
      {item.youtubeVideoId && (
        <a
          className="content-card__yt"
          href={watchUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          YouTube-ல் கேளுங்கள்
        </a>
      )}
    </article>
  )
}
